import React, { useState } from "react";
import { supabase } from "../supabaseClient"; // adjust path to match VendorCard's location

// Drop into VendorCard.jsx, e.g. inside vc-actions alongside Approve/Pending/Deny:
//   import ImpersonateVendorButton from "./ImpersonateVendorButton";
//   <ImpersonateVendorButton vendorId={vendor.id} />

const ImpersonateVendorButton = ({ vendorId }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState("");

  const handleClick = async () => {
    setLoading(true);
    setError("");

    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) throw new Error("Not authenticated as admin.");

      const res = await fetch("/api/admin-impersonate-vendor", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${session.access_token}`,
        },
        body: JSON.stringify({ vendorId }),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Failed to generate login link");

      // Opens in a new tab so it doesn't touch the admin's own session here.
      window.open(data.actionLink, "_blank", "noopener,noreferrer");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: "inline-flex", flexDirection: "column", gap: 3 }}>
      <button
        onClick={handleClick}
        disabled={loading}
        className="vc-action-btn"
        title="Opens their dashboard in a new tab, logged in as them"
      >
        {loading ? "Generating…" : "Log in as vendor"}
      </button>
      {error && <span style={{ fontSize: "0.72rem", color: "#dc2626" }}>{error}</span>}
    </div>
  );
};

export default ImpersonateVendorButton;